namespace Gamification.Gamification {
    export interface ProdottiParametriGlobaliRow {
        UserId?: number;
        TenantId?: number;
        IdProdottoParametriGlobali?: number;
        IdProdotto?: number;
        IdPunteggio?: string;
        PunteggioNome?: string;
        PunteggioValoreIniziale?: number;
        PunteggioNegativo?: number;
        IdCrediti?: string;
        CreditiNome?: number;
        CreditiValoreIniziale?: string;
        IdProdottoTenantId?: number;
        IdProdottoIdTipologiaProdotti?: number;
        IdProdottoIdentifierProdotto?: string;
        IdProdottoNome?: string;
        IdProdottoDescrizione?: string;
    }

    export namespace ProdottiParametriGlobaliRow {
        export const idProperty = 'IdProdottoParametriGlobali';
        export const nameProperty = 'PunteggioNome';
        export const localTextPrefix = 'Gamification.ProdottiParametriGlobali';
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdottoParametriGlobali = "IdProdottoParametriGlobali",
            IdProdotto = "IdProdotto",
            IdPunteggio = "IdPunteggio",
            PunteggioNome = "PunteggioNome",
            PunteggioValoreIniziale = "PunteggioValoreIniziale",
            PunteggioNegativo = "PunteggioNegativo",
            IdCrediti = "IdCrediti",
            CreditiNome = "CreditiNome",
            CreditiValoreIniziale = "CreditiValoreIniziale",
            IdProdottoTenantId = "IdProdottoTenantId",
            IdProdottoIdTipologiaProdotti = "IdProdottoIdTipologiaProdotti",
            IdProdottoIdentifierProdotto = "IdProdottoIdentifierProdotto",
            IdProdottoNome = "IdProdottoNome",
            IdProdottoDescrizione = "IdProdottoDescrizione"
        }
    }
}
